import { Table } from '@rewardops/utils'

export const formatTableData = (content: Record<string, any>) => {
  const rows = []

  for (let i = 1; ; i++) {
    const col1 = content[`row${i}column1` as keyof Table]
    const col2 = content[`row${i}column2` as keyof Table]
    if (col1 === undefined && col2 === undefined) break
    rows.push([col1 || '', col2 || ''])
  }

  return rows
}
